import { z } from 'zod';
import { DEFAULT_CRYPTO_ADDRESS_PATTERN } from '@/shared/config';
import type { TFunction } from 'i18next';
import { createWithdrawAmountSchema } from '@/entities/operation';

export const createWithdrawCryptoFormSchema = (
  t: TFunction,
  minWithdraw?: number,
  maxAvailable?: number,
  checkAddressResult?: string,
  totalAmount?: number,
  invalidMessageResult?: string
) => {
  return z.object({
    assetCode: z.string().nonempty({ message: '' }),
    networkName: z.string().nonempty({ message: '' }),
    cryptoAddress: z
      .string()
      .nonempty({ message: '' })
      .regex(new RegExp(`^[${DEFAULT_CRYPTO_ADDRESS_PATTERN}]+$`), {
        message: t('withdrawMethods.crypto.validation.checkAddressResult'),
      })
      .refine(
        () => {
          if (checkAddressResult === 'invalid') {
            return false;
          }
          return true;
        },
        {
          message:
            invalidMessageResult != ''
              ? invalidMessageResult
              : t('withdrawMethods.crypto.validation.checkAddressResult'),
        }
      ),
    amount: createWithdrawAmountSchema({
      minWithdraw,
      maxAvailable,
      totalAmount,
    }),
    includeFee: z.boolean().default(false),
  });
};
